module.exports = __webpack_public_path__ + "fonts/TTFirs-ExtraBold.18757a1b.ttf";